import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import styled from "styled-components";

const StyledLoader = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
`;

const StyledWrapperLoader = styled.div`
  position: fixed;
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2;
  height: 100%;
`;

const CircularIndeterminate = props => {
  return (
    <StyledWrapperLoader>
      <StyledLoader>
        <center>
          <CircularProgress />
        </center>
      </StyledLoader>
    </StyledWrapperLoader>
  );
};

export default CircularIndeterminate;
